import React, { useState } from 'react';
import { Menu, Eye, Download, FileText, FileType, Upload, History, Save, Plus, RotateCcw, Moon, SunMedium, Languages } from 'lucide-react';
import { useQuiz } from '../context/QuizContext';
import { SIDEBAR_TYPES } from '../mock';
import { t } from '../i18n';
import { useToast } from '../hooks/use-toast';
import ConfirmDialog from './ConfirmDialog';

const Sidebar = ({ onPreview, onImport, onHistory, onExport, onDownloadXml }) => {
  const { addQuestion, clearAll, saveToHistory, lang, setLang, theme, setTheme } = useQuiz();
  const [open, setOpen] = useState(false);
  const [confirmClearOpen, setConfirmClearOpen] = useState(false);
  const { toast } = useToast();

  const handleSaveDraft = () => {
    const saved = saveToHistory();
    if (saved) {
      toast({ title: t('draftSavedTitle', lang), description: t('draftSavedDesc', lang) });
    }
  };

  return (
    <>
      <button className="mg-menu-toggle" onClick={() => setOpen(o => !o)} aria-label="Toggle sidebar">
        <Menu size={16} /> Menu
      </button>
      <aside className={`mg-sidebar ${open ? 'open' : ''}`}>
        {SIDEBAR_TYPES.map(s => (
          <button key={s.id} className="mg-btn" onClick={() => { addQuestion(s.id); setOpen(false); }}>
            {lang === 'en' ? s.labelEn : s.labelId}
          </button>
        ))}

        <div className="mg-divider" />

        <button className="mg-btn warning" onClick={onPreview}>
          <Eye size={16} /> {t('preview', lang)}
        </button>
        <button className="mg-btn success" onClick={onDownloadXml}>
          <Download size={16} /> {t('downloadXml', lang)}
        </button>

        <div className="mg-divider" />

        <button className="mg-btn ghost" onClick={() => onExport('pdf')}>
          <FileText size={16} /> {t('exportPdf', lang)}
        </button>
        <button className="mg-btn ghost" onClick={() => onExport('docx')}>
          <FileType size={16} /> {t('exportDocx', lang)}
        </button>
        <button className="mg-btn ghost" onClick={onImport}>
          <Upload size={16} /> {t('import', lang)}
        </button>
        <button className="mg-btn ghost" onClick={onHistory}>
          <History size={16} /> {t('history', lang)}
        </button>
        <button className="mg-btn ghost" onClick={handleSaveDraft}>
          <Save size={16} /> {t('saveDraft', lang)}
        </button>

        <div className="mg-divider" />

        <button className="mg-btn danger" onClick={() => setConfirmClearOpen(true)}>
          <Plus size={16} /> {t('new', lang)}
        </button>

        <div className="mg-divider" />

        <button className="mg-btn ghost" onClick={() => setLang(lang === 'id' ? 'en' : 'id')}>
          <Languages size={16} /> {lang === 'id' ? 'EN' : 'ID'}
        </button>
        <button className="mg-btn ghost" onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}>
          {theme === 'dark' ? <SunMedium size={16} /> : <Moon size={16} />}
          {theme === 'dark' ? ' Light' : ' Dark'}
        </button>
      </aside>

      <ConfirmDialog
        open={confirmClearOpen}
        onOpenChange={setConfirmClearOpen}
        title={t('confirmClearTitle', lang)}
        description={t('confirmClearDesc', lang)}
        confirmLabel={t('confirmClearAction', lang)}
        cancelLabel={t('cancel', lang)}
        danger
        onConfirm={clearAll}
      />
    </>
  );
};

export default Sidebar;
